import { Input, InputProps } from 'antd'
import { styled } from 'styled-components'
import RedInfoIcon from '../icons/RedInfoIcon'

interface IWizrInput extends InputProps {
  placeholder?: string
  preComponent?: any
  postComponent?: any
  customStyle?: any
  onChange?: any
  value?: any
  onPressEnter?: any
  background?: string
  onSelect?: any
  color?: string
  border?: string
  placeholdercolor?: string
  fontWeight?: string
  fontFamily?: string
  hoverBorder?: string
  errorMessage?: string
  showError?: boolean
  required?: boolean
}

const StyledInput = styled(Input)<any>`
  border-radius: 16px;
  height: 52px;
  padding: 14px;
  font-size: 14px;
  font-style: normal;
  line-height: 18px;
  letter-spacing: 0.25px;
  font-weight: ${(p) => (p.fontWeight !== undefined ? p.fontWeight : '500')};
  font-family: ${(p) => (p.fontFamily !== undefined ? p.fontFamily : 'Montserrat')};
  background: ${(p) => (p.background ? p.background : '#F2F4F9')};
  color: ${(p) => (p.color ? p.color : '#1D1F22')};
  border: 1px solid ${(p) => (p.showError ? '#ff4d4f' : '#d9d9d9')} !important;

  &::placeholder {
    color: ${(p) => (p.placeholdercolor ? p.placeholdercolor : '#A0A0A0')};
  }

  &:hover {
      box-shadow: none;
    border: 1px solid ${(p) => (p.showError ? '#ff4d4f' : '#d9d9d9')} !important;
  }

  &:focus {
    box-shadow: none;
    border: 1px solid ${(p) => (p.showError ? '#ff4d4f' : '#000')} !important;
  }

  &:focus-within {
      box-shadow: none;
    border: 1px solid ${(p) => (p.showError ? '#ff4d4f' : '#000')} !important;
  }

  /* Hide number input spinners across browsers */
  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
`

const ErrorText = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  font-family: Montserrat;
  display: flex;
  align-items: center;
  gap: 6px;
`

const WizrInput = ({
  placeholder = '',
  preComponent = null,
  postComponent = null,
  customStyle = null,
  onChange,
  value = '',
  onPressEnter,
  background,
  onSelect,
  color,
  border,
  placeholdercolor,
  required = false,
  fontWeight,
  fontFamily,
  hoverBorder,
  errorMessage,
  showError = false,
  ...rest
}: IWizrInput): JSX.Element => {
  // Prevent wheel scroll from changing number input values
  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    if (rest.type === 'number' && document.activeElement === e.currentTarget) {
      e.preventDefault()
      e.currentTarget.blur()
    }
  }

  return (
    <>
      <StyledInput
        style={customStyle}
        className="wizr-input"
        placeholder={placeholder}
        prefix={preComponent}
        suffix={postComponent}
        background={background}
        color={color}
        border={border}
        placeholdercolor={placeholdercolor}
        showError={showError}
        {...rest}
        onChange={(ev: any) => {
          onChange(ev?.target?.value)
        }}
        value={value}
        onPressEnter={onPressEnter}
        onSelect={onSelect}
        fontWeight={fontWeight}
        fontFamily={fontFamily}
        hoverBorder={hoverBorder}
        onWheel={handleWheel}
      />
      {showError && errorMessage && (
        <ErrorText>
          <RedInfoIcon />
          <span>{errorMessage}</span>
        </ErrorText>
      )}
    </>
  )
}

export default WizrInput
